WL.PersonWorkplaceRepeater = new Class({

    Extends: TS.domain.RepeaterEditDomain,

    _createCommands: function () {
        var me = this,
            cat;

        me.parent();

        me.CommandCategories.Custom = me.CommandCategories.Custom || { commands: [] };
        cat = me.CommandCategories.Custom.commands;

        cat.push({
            Code: 'RemoveWorkplace',
            IconCode: 'remove',
            handler: 'removeWorkplace'
        });
    },

    _beforeBind: function () {
        var me = this,
            owner,
            cmd_RemoveWorkplace;

        me.parent();

        owner = me._getOwner();

        me.isDeterminedPeriod = ko.computed(function () {
            return (me.Document.EmploymentTypeId() ==WL.Config.EmploymentType.Determined);
        });

        cmd_RemoveWorkplace = me.getCommand('RemoveWorkplace');

        cmd_RemoveWorkplace.Text(owner.RemoveWorkplaceLinkText());
    },

    _hookDocument: function () {
        var me = this,
            employer;

        me.watchProperty(me.Document.EmploymentTypeId, me.onEmploymentTypeIdChanged, me);

        // On select an employer in the browser list of employers:
        employer = me.getDomainProperty('vrPersonActivity_rptPersonWorkplace_browseUniqueID_Property');
        if (employer != null)
            employer.on('selectionChanged', me.onEmployerChanged, me);
    },

    onEmployerChanged: function (selectedPartner) {
        var me = this,
            owner = me._getOwner();

        if (selectedPartner.record == null) {
            // Call method on server:
            owner.performServerCommand({
                cmd: 'LoadEmployerInfo',
                submitModel: true,
                extraData: {
                    WorkplaceUID: me.Document.UID(),
                    UniqueID: null,
                    PartnerId: null,
                    PartnerName: null
                },
                blockUI: true
            });
        }
        else {
            // Call method on server:
            owner.performServerCommand({
                cmd: 'LoadEmployerInfo',
                submitModel: true,
                extraData: {
                    WorkplaceUID: me.Document.UID(),
                    UniqueID: selectedPartner.record.UniqueID,
                    PartnerId: selectedPartner.record.PartnerId,
                    PartnerName: selectedPartner.record.PartnerName
                },
                blockUI: true
            });
        }
    },

    onEmploymentTypeIdChanged: function (newValue) {
        var me = this;

        if (me.Document.EmploymentTypeId() == WL.Config.EmploymentType.Undetermined)
            me.Document.DateTo(null);
    },




    removeWorkplace: function () {
        var me = this,
            owner = me._getOwner();

        // instruct parent model to perform command
        owner.performServerCommand('RemoveWorkplace', true, { WorkplaceUID: me.Document.UID() });
    }


});